import { createFileRoute } from '@tanstack/react-router'

import { WorkbenchPage } from '@/pages/workbench/Workbench.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/workbench/',
)({
  component: WorkbenchPage,
})
